import { getEnvVar } from '@/shared/utils/envVarConfig';

export function getQrCodeFileName(): string {
  const environment = getEnvVar('VITE_ENVIRONMENT');

  if (environment === 'prod') {
    return 'qr-prod.png';
  }
  if (environment === 'staging') {
    return 'qr-staging.png';
  }
  // dev or any other environment
  return 'qr-dev.png';
}
